export default {
  'create-account-247-support': '24/7 Support',
  'create-account-secure': '100% Secure',
  'create-account-fast': 'Fast & Easy Withdrawals',
  'create-account-gambling-commission': 'Gambling Commission of Great Britain',

  'create-account-promotion-amount': '##AMOUNT##',
  'create-account-promotion-type': 'Welcome Bonus',
  'create-account-promotion-description': 'Up to ##UPTO_AMOUNT## on your first deposit',
  'create-account-promotion-spins-bonus': '+ ##SPINS_AMOUNT## Bonus Spins',

  'create-account-promotion-terms-row':
    '<a href="/playerprotection">18+.</a> <a href="/promotions?scrollto=welcome_promoterms" class="ui-link">Terms apply.</a> Please gamble responsibly. <a href="http://www.gamblingtherapy.org" target="_blank">www.Gamblingtherapy.org</a>',

  'create-account-promotion-terms-gb':
    '<a href="/playerprotection">18+.</a> New players only. Min. deposit %minDeposit%. Max. bonus bet is %maxBonusBet%. Bonus spins on selected games only and must be used within 72 hours. Winnings from Bonus spins credited as bonus funds and capped at %maxCap%. Bonus funds expire in 30 days, unused bonus funds will be removed. Welcome Offer is %firstBonus% match up to %firstUpTo% plus %firstSpins% bonus spins on your 1st deposit, %secondBonus% match up to %secondUpTo% on your 2nd deposit. Bonus funds are separate to Cash funds, and are subject to 35x wagering the total bonus & cash. Only bonus funds count towards wagering contribution. Affordability checks apply. <a href="/promotions?scrollto=welcome_promoterms" class="ui-link">Terms apply.</a> Please gamble responsibly. <a href="http://www.begambleaware.org/" target="_blank">BeGambleAware.org</a>.',

  //Sign in btn text
  'create-account-promotion-sign-in': 'Already have an account?',
  'create-account-close': 'close',

  // step 1
  'personal-details-title': 'Sign up',
  'personal-details-supporting-text': '',

  // step 2
  'address-details-title': 'Nearly There!',
  'address-details-supporting-text': "You're flying through!",

  // step 3
  'account-details-title': '%firstname%',
  'account-details-supporting-text': 'This is the last step!',

  // helpandsupport_contactinfo_h2
  // gi_account_information

  'trustly-personal-details-create-account': 'Continue',

  'marketing-preferences-title': 'Communication Preferences',
  'marketing-preferences-description':
    'Ursa Casino offers its Player Community unique Daily Deals & Monthly Highlights such as match bonuses, bonus spins, free spins, cashback offers, tournaments, leaderboards, real life prizes, experiences and holidays. To hear about these, please select below:',
  'marketing-preferences-post-text': 'You can update your communication preferences at any time in your My Account section.',
  'marketing-preferences-label-cross-brand': 'I want to hear about exclusive offers from your casino network.',
  'marketing-preferences-label-brand-only': 'I want to hear about exclusive offers from your casino only.',
  'marketing-preferences-label-email': 'I want to hear about offers via <strong>email</strong>',
  'marketing-preferences-label-sms': 'I want to hear about offers via <strong>sms</strong>',
  'marketing-preferences-label-phone-call': 'I want to hear about offers via <strong>phone call</strong>',
  'marketing-preferences-label-post': 'I want to hear about offers via <strong>post</strong>',

  'marketing-preferences-unified-description':
    '<strong>Don\'t miss</strong> the latest promotions and exclusive offers from Ursa Casino and the brands managed by <a href="/brands" target="_blank">our network</a>. Choose how you\'d like to receive communication from us.',
  'marketing-preferences-unified-label-email': 'Email',
  'marketing-preferences-unified-label-sms': 'SMS',
  'marketing-preferences-unified-label-phone-call': 'Phone',
  'marketing-preferences-unified-label-phone-post': 'Post',
};
